<template>
    <sa-page-layout :btnNewVisible="btnNewVisible" :btnRefreshVisible="true" @refresh="onRefresh" :pathResource="pathResource" :linkedit="linkedit" :showModalLoading="showModalLoading">
        <template slot="table-body">
            <graffidi-applicativi-list-component ref="GraffidiApplicativiListComponent" @afterLoadData="onAfterLoadData"></graffidi-applicativi-list-component>
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import GraffidiApplicativiListComponent from "../components/GraffidiApplicativiListComponent.vue";

export default {
    components: { SaPageLayout, GraffidiApplicativiListComponent },
    data() {
        return {
            btnNewVisible: true,
            pathResource: "",
            linkedit: "/graffidiapplicativi",
            showModalLoading: false,
            listKey: 0,
        };
    },
    mounted() {
        let me = this;
        me.loadData();
    },
    methods: {
        loadData() {
            let me = this;
            me.showModalLoading = true;
            me.$refs.GraffidiApplicativiListComponent.loadData();
        },
        onRefresh() {
            let me = this;
            me.loadData();
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
    },
};
</script>

<style></style>
